(function (angular) {
  "use strict";

  angular.module('myApp').component("inputFile", {
    templateUrl: "/core/components/inputFile/inputFile.tpl.html",
    transclude: true,
    bindings: {
      name: '@',
      label: '@',
      required: '@',
      service: '=',
      disabledIf: '<?'
    },
    controller: ['$scope', 'Upload', '$timeout', '$http',
      function ($scope, Upload, $timeout, $http) {

        var model = null;
        $scope.fileUrl = null;
        $scope.uploadFiles = function (file, errFiles) {
          $scope.f = file;
          $scope.errFile = errFiles && errFiles[0];
          if (file) {
            file.upload = Upload.upload({
              url: 'api/file',
              data: {
                file: file
              }
            });

            file.upload.then(function (resp) {
              $timeout(function () {
                if (resp.data.success) {
                  $scope.$ctrl.service.dto[$scope.$ctrl.name] = resp.data.file;
                  $scope.fileUrl = resp.data.fileUrl;
                  $scope.$apply();
                } else {
                  $scope.$ctrl.service.dto[$scope.$ctrl.name] = null;
                  $scope.fileUrl = null;
                  $scope.f = null;
                }
              });
            }, function (resp) {
              if (resp.status > 0)
                $scope.errorMsg = resp.status + ': ' + resp.data;
            }, function (evt) {
              file.progress = Math.min(100, parseInt(100.0 *
                evt.loaded / evt.total));
            });
          }
        };

        

        this.$onInit = function () {

          $timeout(function(){
            model = $scope.$ctrl.service.dto[$scope.$ctrl.name];

            if (model != null) {
              $http({
                url: 'api/file/get-prefix-url',
                method: 'GET',
                params: {
                  file: model
                }
              }).then(function (resp) {
                $scope.fileUrl = resp.data.url;
              });
            }

          }, 500);
        };

        
        $scope.fileLink = function () {
          setTimeout(function () {
            dataNeedSaving = false;
          }, 200);      
        };  

      }
    ],
  });

}(window.angular));
